import { useNotificationStore } from '@/stores/notification.store'
import type { Notification } from '@/stores/notification.store'

type NotificationOptions = Pick<Notification, 'actionLabel' | 'onAction' | 'location' | 'title'> & {
	timeout?: number
}

export function useNotification() {
	const store = useNotificationStore()

	function success(message: string, options?: NotificationOptions) {
		store.add({ type: 'success', message, ...options })
	}

	function error(message: string, options?: NotificationOptions) {
		store.add({ type: 'error', message, ...options })
	}

	function warning(message: string, options?: NotificationOptions) {
		store.add({ type: 'warning', message, ...options })
	}

	function info(message: string, options?: NotificationOptions) {
		store.add({ type: 'info', message, ...options })
	}

	return { success, error, warning, info }
}
